/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import {translate} from '@ion/core/src/locale/locale';
import {dlsColor} from '@ion/dls/src/theme/theme';
import {DLSTheme, IconSize} from '@ion/dls/src/types/types';
import {EventHistoryBadgeIcon} from '../icons/current/EventHistoryBadgeIcon';
import {ThunderIcon} from '../icons/current/ThunderIcon';

const useStyles = makeStyles((theme: DLSTheme) => {
  return {
    urgentContainer : {
      gap             : '8px',
      height          : '32px',
      display         : 'flex',
      padding         : '8px',
      alignItems      : 'center',
      borderRadius    : '8px',
      backgroundColor : dlsColor('grey6')
    },
    currentnotifications : {
      gap     : '4px',
      width   : '286px',
      height  : '16px',
      display : 'flex'
    },
    urgentText : {
      alignItems    : 'center',
      color         : dlsColor('grey1'),
      display       : 'block',
      fontFamily    : 'Roboto',
      fontSize      : '12px',
      fontWeight    : 400,
      lineHeight    : '16px',
      letterSpacing : '0.5px'
    },
    notificationsIcon : {
      alignItems     : 'center',
      display        : 'flex',
      height         : '16px',
      justifyContent : 'center',
      width          : '16px'
    },
    thunderIcon : {
      alignItems     : 'center',
      display        : 'flex',
      height         : '16px',
      justifyContent : 'center',
      width          : '16px'
    }
  };
});

/**
 * Component for rendering notification clear dialog
 * 
 * ```typescript
 * 
 * import {NotificationClearDialog} from '@ion/dls/src/notifications'
 *
 * 
 *
 * ```
 *
 */
export const NotificationClearDialog = () => {
  const classes = useStyles();
  const prefix  = translate('notifications:panel.urgent.clearPrefix');
  const suffix  = translate('notifications:panel.urgent.clearSuffix');

  return (
    <div className={classes.urgentContainer}>
      <div className={classes.currentnotifications}>
        <span className={classes.thunderIcon}>
          <ThunderIcon />
        </span>
        <span className={classes.urgentText}>
          {prefix}
        </span>
        <span className={classes.notificationsIcon}>
          <EventHistoryBadgeIcon size={IconSize.small} color={dlsColor('grey2')} />
        </span>
        <span className={classes.urgentText}>
          {suffix}
        </span>
      </div>
    </div>
  );
};

export default React.memo(NotificationClearDialog);
